import './results.scss';
import leaderboard from './leaderboard.json'

class ResultsControls {
  constructor(lang, theme) {
    this.lang = lang;
    this.theme = theme;
  }

  buildResultsSection(lang, theme) {
    let resultsSection = document.createElement('div');
    let resultsTable = document.createElement('table');
    let resultsThead = document.createElement('thead');
    let resultsThNick = document.createElement('th');
    let resultsThScore = document.createElement('th');
    let resultsThRank = document.createElement('th');
    let resultsTr = document.createElement('tr');
    let resultsTdUser = document.createElement('td');
    let resultsName = document.createElement('span');
    let resultsAvatar = document.createElement('div');
    let resultsTdScore = document.createElement('td');
    let resultsTdRank = document.createElement('td');

    let mainSection = document.querySelector('.main-section');

    resultsSection.classList.add('results-section');
    resultsTable.classList.add('leaderboard');
    resultsThead.classList.add('leaderboard__thead');
    resultsThNick.classList.add('leaderboard__th');
    resultsThScore.classList.add('leaderboard__th');
    resultsThRank.classList.add('leaderboard__th');
    resultsTdUser.classList.add('leaderboard__user');
    resultsName.classList.add('leaderboard__name');
    resultsAvatar.classList.add('leaderboard__avatar');
    resultsTdScore.classList.add('leaderboard__score');
    resultsTdRank.classList.add('leaderboard__rank');

    if (theme === 'dark') {
      resultsSection.classList.add('results-section_theme-color_dark');
    } else {
      resultsSection.classList.add('results-section_theme-color_light');
    }

    if (lang === 'ru') {
      resultsSection.classList.add('results-section_lang_ru');
    } else {
      resultsSection.classList.add('results-section_lang_en');
    }

    resultsThead.appendChild(resultsThNick);
    resultsThead.appendChild(resultsThScore);
    resultsThead.appendChild(resultsThRank);
    resultsTable.appendChild(resultsThead);
    resultsTdUser.appendChild(resultsAvatar);
    resultsTdUser.appendChild(resultsName);
    resultsTr.appendChild(resultsTdUser);
    resultsTr.appendChild(resultsTdScore);
    resultsTr.appendChild(resultsTdRank);

    for (let i = 0; i < leaderboard.length; i++) {
      resultsAvatar.style.backgroundImage = `url("${leaderboard[i].avatar}")`;
      resultsName.textContent = leaderboard[i].name;
      resultsTdScore.textContent = leaderboard[i].score;
      resultsTdRank.style.backgroundImage = `url("${leaderboard[i].rank_image}")`;

      const copyCard = resultsTr.cloneNode(true);
      resultsTable.appendChild(copyCard);
    }

    resultsSection.appendChild(resultsTable);
    mainSection.appendChild(resultsSection);
  }

  buildResultsMessage(lang, theme) {
    this.buildResultsSection(lang, theme);

    let resultMessage = document.createElement('div');
    let resultsMessageButtonBack = document.createElement('div');
    let resultsMessageText = document.createElement('p');
    let resultsMessageImg = document.createElement('div');
    let resultsMessageButtonAgain = document.createElement('div');

    let resultsSection = document.querySelector('.results-section');

    resultMessage.classList.add('results-message');
    resultsMessageButtonBack.classList.add('results-message__button-back');
    resultsMessageText.classList.add('results-message__text');
    resultsMessageImg.classList.add('results-message__img');
    resultsMessageButtonAgain.classList.add('results-message__button-again');

    resultMessage.appendChild(resultsMessageButtonBack);
    resultMessage.appendChild(resultsMessageText);
    resultMessage.appendChild(resultsMessageImg);
    resultMessage.appendChild(resultsMessageButtonAgain);
    resultsSection.prepend(resultMessage)

    if (this.lang === 'ru') {
      if (leaderboard[0].score == 30) {
        resultsMessageText.textContent = `Поздравляю! Вы набрали максимальное количество очков: ${leaderboard[0].score}, ваш ранг "${leaderboard[0].rank_ru}"`
      } else {
        resultsMessageText.textContent = `Количество ваших очков: ${leaderboard[0].score}, ваш ранг "${leaderboard[0].rank_ru}". Попробуете еще раз?`
      }
    } else {
      if (leaderboard[0].score == 30) {
        resultsMessageText.textContent = `Winner winner - chicken dinner! You score is max - 30 points! Your rank is "${leaderboard[0].rank_en}"`
      } else {
        resultsMessageText.textContent = `You score points: ${leaderboard[0].score}, your rank is "${leaderboard[0].rank_en}". Try again?`
      }
    }

    resultsMessageImg.style.backgroundImage = `url("${leaderboard[0].rank_image}")`;

    if (leaderboard[0].score == 30) {
      resultsMessageButtonAgain.style.display = 'none';
    } 

  }
}

export { ResultsControls };